import { services } from '@/mocks/home';

export default function ServiceSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-50 text-secondary-700 text-xs font-medium mb-4">
            核心服务
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            一站式数字生活服务
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            六大核心服务，全面满足你的在线生活需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service) => (
            <div
              key={service.id}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-secondary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-50 text-secondary-600 mb-4 group-hover:bg-secondary-500 group-hover:text-background-50 transition-colors">
                <i className={`${service.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {service.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}